import { render, staticRenderFns } from "./AvSkeletonMediaTabs.vue?vue&type=template&id=0563017e"
import script from "./AvSkeletonMediaTabs.vue?vue&type=script&lang=ts"
export * from "./AvSkeletonMediaTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports